import { useEffect, useState } from 'react';

import { loadTranslationMessages, peekTranslationMessages } from '../i18n';

// ********************************************************************************
/** Whether `locale`'s catalog is in memory, and requests it when it is not */
export function useLocaleReady(locale: string | undefined): boolean {
  // -- State ---------------------------------------------------------------------
  const [ready, setReady] = useState(
    () => !locale || Boolean(peekTranslationMessages(locale)),
  );

  // -- Effect --------------------------------------------------------------------
  useEffect(() => {
    if (!locale || peekTranslationMessages(locale)) {
      setReady(true);
      return undefined;
    }

    let current = true;

    setReady(false);

    // loadTranslationMessages returns the source strings
    // rather than rejecting, so this can never hold the loader open forever
    loadTranslationMessages(locale).then(() => {
      if (current) setReady(true);
    });

    return () => {
      current = false;
    };
  }, [locale]);

  // -- Return --------------------------------------------------------------------
  return ready;
}
